import React from 'react';
import Lottie from 'react-lottie';

import {LottieViewProps} from './LottieView.props';

const LottieView: React.FC<LottieViewProps> = ({
  source,
  autoPlay,
  loop = false,
  style,
  onAnimationFinish = () => null,
}) => (
  <Lottie
    options={{animationData: source, autoPlay, loop}}
    width={style?.width ?? '100%'}
    height={style?.height ?? '100%'}
    eventListeners={[
      {
        eventName: 'complete',
        callback: isCanceled => onAnimationFinish(isCanceled),
      },
    ]}
  />
);

export default LottieView;
